import { Box, EmptyState } from '@shopify/polaris';
import { SettingUrls } from 'constants/SettingsUrls';
import PagePickupBird from 'layouts/page/PagePickupBird';
import { useNavigate } from 'react-router';
import { transformToCdnUrl } from 'utils/google-storage-util';

const NotFoundPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <PagePickupBird hideFooter>
            <Box paddingBlockStart={'1200'}>
                <EmptyState
                    heading={'404'}
                    action={{
                        content: 'Go to Dashboard',
                        onAction() {
                            navigate(SettingUrls.dashboard);
                        },
                    }}
                    image={transformToCdnUrl('embedded-assets/404_illustration.webp')}
                >
                    <p>Oops! Page not found</p>
                </EmptyState>
            </Box>
        </PagePickupBird>
    );
};

export default NotFoundPage;
